export default {
    BACKGROUND: {
        key: 'background'
    },
    BACKGROUND_SMALL: {
        key: 'backgroundSmall'
    },
    PATH_FAVICON: {
        key: 'pathFavicon'
    },
    PATH_LOGO: {
        key: 'pathLogo'

    },
    TITLE: {
        key: 'title'
    }
};